import React from 'react';
import Logo from './Logo';
import './LoadingScreen.css';

const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <div className="loading-content">
        <Logo size="large" animated={true} />
        <div className="loading-spinner">
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
          <div className="spinner-ring"></div>
        </div>
        <p className="loading-text">Carregando...</p>
      </div>
    </div>
  );
};

export default LoadingScreen;
